import { render, staticRenderFns } from "./CommunitySelection.vue?vue&type=template&id=1ff32ae2&"
import script from "./CommunitySelection.vue?vue&type=script&lang=js&"
export * from "./CommunitySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports